import { ExceptionType, PaginationParams } from '@/shared/types';
import { DateRange } from 'react-day-picker';

export abstract class ProcessKey {
  static ALL = ['processes'];
  static LIST = [...ProcessKey.ALL, 'list'];
  static LIST_PAGED = (pagination: PaginationParams) => [
    ...ProcessKey.LIST,
    pagination,
  ];
  static BY_ID = (processId: number) => [...ProcessKey.ALL, 'by-id', processId];
  static BY_BUSINESS_AREA = (businessAreaId?: number) => [
    ...ProcessKey.ALL,
    'by-business-area',
    businessAreaId,
  ];
  static BY_BUSINESS_AREA_PAGED = (
    businessAreaId: number,
    pagination: PaginationParams,
  ) => [...ProcessKey.BY_BUSINESS_AREA(businessAreaId), pagination];
  static BY_COMPANY = (companyId: number) => [
    ...ProcessKey.ALL,
    'by-company',
    companyId,
  ];
  static BY_COMPANY_PAGED = (
    companyId: number,
    pagination: PaginationParams,
  ) => [...ProcessKey.BY_COMPANY(companyId), pagination];
  static BY_ORGANIZATION = (organizationId: number) => [
    ...ProcessKey.ALL,
    'by-organization',
    organizationId,
  ];
  static BY_ORGANIZATION_PAGED = (
    organizationId: number,
    pagination: PaginationParams,
  ) => [...ProcessKey.BY_ORGANIZATION(organizationId), pagination];
  static BY_USER = (userId: number) => [...ProcessKey.ALL, 'by-user', userId];
  static BY_USER_PAGED = (userId: number, pagination: PaginationParams) => [
    ...ProcessKey.BY_USER(userId),
    pagination,
  ];
  static AUTOMATIONS_PERFORMANCE = (
    processId: number,
    dateRange?: DateRange,
  ) => [...ProcessKey.BY_ID(processId), 'automations-performance', dateRange];
  static LABOUR_AUTOMATED = (
    processId: number,
    dateRange?: DateRange,
    filter?: string,
  ) => [...ProcessKey.BY_ID(processId), 'labour-automated', dateRange, filter];
  static TOTAL_RETURN = (
    processId: number,
    dateRange?: DateRange,
    filter?: string,
  ) => [...ProcessKey.BY_ID(processId), 'total-return', dateRange, filter];
  static LAST_RUN = (
    processId: number,
    filter?: string,
    result?: boolean,
    exceptionType?: ExceptionType,
  ) => [
    ...ProcessKey.BY_ID(processId),
    'last-run',
    filter,
    result,
    exceptionType,
  ];
  static OVERALL_RUNS = (
    processId: number,
    dateRange?: DateRange,
    filter?: string,
    result?: boolean,
    exceptionType?: ExceptionType,
  ) => [
    ...ProcessKey.BY_ID(processId),
    'overall-runs',
    dateRange,
    filter,
    result,
    exceptionType,
  ];
}
